import React from "react";
import Navbar from "./Navbar";
import { Outlet } from "react-router-dom";
import Footer from "../Components/Footer/Footer";
import FloatingButton from "./FloatingButton";
import FloatingButtonPhone from "./FloatingButtonPhone";

const Layout = () => {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
      <FloatingButton />
      <FloatingButtonPhone />
    </>
  );
};

export default Layout;
